import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "../AddDevice/AddDevice.scss";
import useApi from "../../hook/useAPI";
import { AUTH, DEVICE, MESSAGE } from "../../utils/const";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { DEVICE_CATEGORIES, getDeviceIcon } from "../../utils/deviceIcons";

const getApiErrorMessage = (err, fallback = MESSAGE.UNEXPECTED_ERR) =>
  err?.response?.data?.message ||
  err?.response?.data?.error ||
  fallback;

const normalizeDeviceForm = (device) => ({
  name: device?.name ?? "",
  simCardNumber: device?.simCardNumber ?? "",
  imeiNumber: device?.imeiNumber ?? "",
  assetId: device?.assetId ?? "",
  type: device?.type ?? "1nce",
  deviceCategory: device?.deviceCategory ?? "smartphone",
});

const DeviceAddModal = ({ show, handleClose, ID, AddDevice }) => {
  const { getData, postData, putData } = useApi();
  const deviceNamePattern = /^[a-zA-Z\s-_]*$/;
  const initialState = {
    name: "",
    simCardNumber: "",
    imeiNumber: "",
    assetId: "",
    type: "1nce",
    deviceCategory: "smartphone",
  };

  const [deviceData, setDeviceData] = useState(initialState);
  const deviceStoredData = JSON.parse(localStorage.getItem('deviceData')) || [];

  useEffect(() => {
    if (ID) {
      const fetchDevice = async () => {
        try {
          const response = await getData(`${DEVICE?.GET_CURRENT_DEVICE_STATUS}`, ID);
          console.log(response, "response");
          if (response.status == 200 && response?.data.length > 0) {
            setDeviceData(normalizeDeviceForm(response.data[0]));
          } else {
            toast.error(MESSAGE.SOMETHING_WRONG);
          }
        } catch (err) {
          toast.error(getApiErrorMessage(err, "Failed to load device details."));
        }
      };
      fetchDevice()
    } else {
      setDeviceData(initialState)
    }
  }, [ID])

  const handleSubmit = async (formValues) => {
    let oncetoken = localStorage.getItem("1nce_access_token");

    if (!oncetoken) {
      const resOnce = await getData(`${AUTH?.ONCE_AUTHENTICATE}`);
      localStorage.setItem('1nce_access_token', resOnce?.access_token);
      oncetoken = localStorage.getItem("1nce_access_token");
    }

    const data = {
      simId: formValues?.simCardNumber,
      token: oncetoken,
    };

    const res = await postData(DEVICE.GET_SINGLE_SIM_DETAIL, data).catch(async (err) => {
      if (err.response.data.error == "Unauthorized") {
        const resOnce = await getData(`${AUTH?.ONCE_AUTHENTICATE}`);
        localStorage.setItem('1nce_access_token', resOnce?.access_token);
        await res();
      } else {
        toast.error(err?.response?.data?.error)
      }
    })

    if (formValues?.simCardNumber !== res?.iccid) {
      toast.error(MESSAGE.SIM_VALIDATION);
    } /*else if (formValues.imeiNumber !== res?.imei) {
      toast.error(MESSAGE.IMEI_VALIDATION);
    }*/ else {
      try {
        if (ID) {
          const data = {
            assetId: formValues.assetId,
            imeiNumber: formValues.imeiNumber,
            name: formValues.name,
            simCardNumber: formValues.simCardNumber,
            type: formValues.type,
            deviceCategory: formValues.deviceCategory,
          };

          const response = await putData(`${DEVICE.CREATE_DEVICE}/${ID}`, data);
          if (response?.status == 200) {
            toast.success(response?.message || "Device updated successfully");
            handleClose();
            AddDevice();
          } else {
            toast.error(response?.message || response?.error || MESSAGE.SOMETHING_WRONG);
          }
        } else {
          const response = await postData(DEVICE.CREATE_DEVICE, formValues);

          if (response?.status === 200) {
            toast.success(response?.message || MESSAGE.DEVICE_CREATED);
            handleClose();
            AddDevice();
          } else {
            toast.error(response?.message || response?.error || MESSAGE.SOMETHING_WRONG);
          }
        }
      } catch (error) {
        toast.error(getApiErrorMessage(error));
      }
    }
  }
  const deviceSchema = Yup.object().shape({
    name: Yup.string()
      .required("Please enter device name")
      .matches(
        deviceNamePattern,
        "Please enter a valid device name only characters allowed."
      ),
    simCardNumber: Yup.string()
      .matches(/^\d{19}$/, "SIM number must be exactly 19 digits")
      .required("Please enter SIM card number"),
    imeiNumber: Yup.string()
      .matches(/^\d+$/, "IMEI number contains number only")
      .min(15, "IMEI should be atleast 15 characters long").max(16, "IMEI must be exactly 16 characters long")
      // .length(16, "IMEI must be exactly 16 characters long")
      .required("Please enter IMEI number"),
    assetId: Yup.string(),
    // .required("Please enter phone number"),
    type: Yup.string()
      .required("Please select connectivity type"),
    deviceCategory: Yup.string()
      .oneOf(DEVICE_CATEGORIES.map((c) => c.value))
      .required("Please select device category"),
  });

  return (
    <Modal show={show} onHide={handleClose} centered size="md" className="modal fade bs_common_modal add-device-modal" >
      <Modal.Body>

        <Modal.Header closeButton>
        </Modal.Header>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="dialog-content-body modalbody-form-filed">
                <h4 className="dialog-title">{ID ? "Edit Device" : "Add Device"}</h4>
                <Formik
                  onSubmit={(formData) => handleSubmit(formData)}
                  initialValues={deviceData}
                  enableReinitialize
                  validationSchema={deviceSchema}
                // innerRef={formRef}
                >
                  {({ errors,
                    values,
                    touched,
                    isValid,
                    dirty,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    setFieldValue,
                  }) => (
                    <Form>
                      <div className="add-device-form">
                        <div className="row gx-md-5">
                          <div className="col-md-6">
                            <div className="form_field_wrapper">
                              <label>Device Name</label>
                              <Field
                                className="form-control"
                                placeholder="Enter your Device Name"
                                type="text"
                                label="Title"
                                name="name"
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              // disabled
                              />
                              {/* <select
                                className="form-select"
                                aria-label="Default select example"
                                value={values.name}
                                name="name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                              >
                                <option value="">Select Device Name</option>
                                {deviceStoredData.map((item, index) => (
                                  <option key={index} value={item.value}>{item.name}</option>
                                ))}
                              </select> */}
                              {errors.name && touched?.name && (
                                <div
                                  className="error-message error-message-height"
                                  id="name"
                                >
                                  {errors.name}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form_field_wrapper">
                              <label>SIM Card Number</label>
                              <Field
                                className="form-control"
                                placeholder="Enter your sim card number"
                                type="text"
                                label="Title"
                                name="simCardNumber"
                                value={values.simCardNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              // disabled
                              />
                              {errors.simCardNumber && touched?.simCardNumber && (
                                <div
                                  className="error-message error-message-height"
                                  id="simCardNumber"
                                >
                                  {errors.simCardNumber}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form_field_wrapper">
                              <label>IMEI Number</label>
                              <Field
                                className="form-control"
                                placeholder="Enter your IMEI number"
                                type="text"
                                label="Title"
                                name="imeiNumber"
                                value={values.imeiNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              // disabled
                              />
                              {errors.imeiNumber && touched?.imeiNumber && (
                                <div
                                  className="error-message error-message-height"
                                  id="imeiNumber"
                                >
                                  {errors.imeiNumber}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form_field_wrapper">
                              <label>Phone Number</label>
                              <Field
                                className="form-control"
                                placeholder="Enter your phone number"
                                type="text"
                                label="Title"
                                name="assetId"
                                value={values.assetId}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              // disabled
                              />
                              {errors.assetId && touched?.assetId && (
                                <div
                                  className="error-message error-message-height"
                                  id="assetId"
                                >
                                  {errors.assetId}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="form_field_wrapper">
                              <label>Device category</label>
                              <div className="device-category-toggle" role="group" aria-label="Device category">
                                {DEVICE_CATEGORIES.map((cat) => (
                                  <button
                                    key={cat.value}
                                    type="button"
                                    className={`device-category-chip${values.deviceCategory === cat.value ? ' selected' : ''}`}
                                    onClick={() => setFieldValue('deviceCategory', cat.value)}
                                  >
                                    <img src={getDeviceIcon(cat.value)} alt="" />
                                    <span>{cat.label}</span>
                                  </button>
                                ))}
                              </div>
                              {errors.deviceCategory && touched?.deviceCategory && (
                                <div className="error-message error-message-height">{errors.deviceCategory}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-sm-12 col-md-6">
                            <div className="form_field_wrapper select-half">
                              <label>Connectivity / SIM type</label>
                              <select
                                className="form-select"
                                aria-label="SIM connectivity type"
                                value={values.type}
                                name="type"
                                onChange={handleChange}
                                onBlur={handleBlur}
                              >
                                <option value="">Select connectivity</option>
                                <option value="1nce">1NCE</option>
                              </select>
                              {errors.type && touched?.type && (
                                <div className="error-message error-message-height">{errors.type}</div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="create-account-btn mt-5">
                          <button type="submit" onClick={handleSubmit}>Connect Device</button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeviceAddModal;
